import {patchState, signalStore, withComputed, withMethods, withProps, withState} from '@ngrx/signals';
import {User} from 'src/app/infrastructure/moovement-api/models/user';
import {computed, inject} from '@angular/core';
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';
import {Persistable, SynchronizationStatus} from 'src/app/infrastructure/moovement-api/models/asset';
import {environment} from 'src/app/environments/environment';
import {NetworkStatusStore} from 'src/app/infrastructure/network/network-status.store';

interface UserState {
  loading: boolean;
  user: User | undefined;
}

const initialState: UserState = {
  loading: true,
  user: undefined
};

const ADMIN = 'ADMIN';
const USER = 'USER';

export const UserStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withProps(() => ({
    farmStore: inject(FarmStore),
    networkStatusStore: inject(NetworkStatusStore)
  })),
  withMethods((store) => ({
    setLoading(loading: boolean) {
      patchState(store, {loading});
    },
    setUser(user: User) {
      patchState(store, {user, loading: false});
    }
  })),
  withComputed(({user}) => ({
    isAdmin: computed(() => {
      const roles = user()?.roles;
      if (!roles) return false;

      return roles.includes(ADMIN);
    })
  })),
  withComputed(({user, isAdmin, farmStore}) => ({
    canEdit: computed(() => {
      if (isAdmin()) return true;

      const farmId = farmStore.farm()?.id;
      const allFarmRoles = user()?.farmRoles
      if (!farmId || !allFarmRoles) return false;

      const farmRoles = allFarmRoles[farmId];
      if (!farmRoles) return true;

      return farmRoles.includes(ADMIN) || farmRoles.includes(USER);
    })
  })),
  withMethods(({canEdit, networkStatusStore}) => ({
    canEditPersistable(persistable?: Persistable) {
      if (!persistable || !canEdit()) return false;

      return environment.platform == 'web' || networkStatusStore.isOnline() || persistable.synchronizationStatus === SynchronizationStatus.syncPending;
    },
    canDeletePersistable(persistable?: Persistable) {
      if (!persistable || !canEdit()) return false;

      return environment.platform == 'web' || networkStatusStore.isOnline() || persistable.synchronizationStatus !== SynchronizationStatus.deleted;
    }
  }))
);
